export default __webpack_public_path__ + "static/accommodations-1eb9f9e421d7320e920f31f425c89fe5.png";